import NormalAPI from "../../api";
import urls from "../../api/urls";

const {
  GET_PINCODE_SERVICEABILITY,
  EXPORT_PINCODE_SERVICEABILITY,
  EXPORT_PINCODE_METADATA,
  TOGGLE_SERVICE_URL,
  TOGGLE_ACTIVE_URL,
  GET_ALL_STATE,
  GET_STATES_HYPERLOCAL,
  GET_CITIES_BY_STATE,
  GET_HYPERLOCAL_ZONES,
  UPDATE_HYPERLOCAL_ZONE,
  CREATE_HYPERLOCAL_ZONE,
  HYPERLOCAL_PINCODE_AREA_MASTER,
  BULK_UPLOAD_PINCODE,
  BULK_UPLOAD_COURIER_PINCODE,
  BULK_UPLOAD_ECOMM_PINCODE,
  UPDATE_TRANSIT_DAYS,
  GET_PINCODE_METADATA,
  GET_SERVICEABILITY_STATES,
  GET_SERVICEABILITY_CITIES,
  CREATE_SERVICEABILITY_CITY,
  UPDATE_SERVICEABILITY_CITY,
  GET_ZONES,
  GET_BILLING_ZONES,
  CREATE_ZONE,
  CREATE_BILLING_ZONE,
  BULK_UPDATE_ZONES,
  BULK_UPLOAD_PINCODE_METADATA,
  BULK_UPLOAD_MCN_PINCODE,
  CREATE_SINGLE_PINCODE_METADATA
} = urls;

export const PincodeService = {
  createDelcaperZone: async (cityName, payload) => {
    try {
      const url = `${CREATE_HYPERLOCAL_ZONE}?city=${encodeURIComponent(cityName)}`;

      const response = await NormalAPI.Api(url).postWithHeader(payload);

      if (response?.status) {
        return response.response.data;
      }

      throw new Error(response?.response?.data?.message || "Failed to create Delcaper Zone");
    } catch (error) {
      console.error("Delcaper Zone Create Error:", error);
      throw error;
    }
  },
  getHyperlocalPincodeAreaMaster: async (stateName, cityName) => {
    try {
      const url =
        `${HYPERLOCAL_PINCODE_AREA_MASTER}?state=${encodeURIComponent(stateName)}&city=${encodeURIComponent(cityName)}`;

      const response = await NormalAPI.Api(url).getCustomHeader({
        headers: {
          accept: "application/json, text/plain, */*",
        }
      });

      if (response?.status) {
        const data = response?.response?.data;

        // Handle multiple backend response styles
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.items)) return data.items;
        if (Array.isArray(data?.data?.items)) return data.data.items;
        if (Array.isArray(data?.pincodes)) return data.pincodes;

        return [];
      }

      throw new Error(response?.message || "Failed to fetch hyperlocal pincode master");
    } catch (error) {
      console.error("Error fetching hyperlocal pincode master:", error);
      throw error;
    }
  },
  getPincodeServiceability: async (params, options = {}) => {
    const queryParams = {
      page: params.page || 1,
      limit: params.limit || 20,
      business_line: params.business_line,
    };

    if (params.is_active !== undefined && params.is_active !== null) {
      queryParams.is_active = params.is_active;
    }

    if (params.search) {
      queryParams.global_search = params.search;
    }
    if (params.state) {
      queryParams.state = params.state;
    }
    if (params.city) {
      queryParams.city = params.city;
    }
    if (params.pincode) {
      queryParams.pincode = params.pincode;
    }
    if (params.zone) {
      queryParams.zone = params.zone;
    }
    if (params.hub_name) {
      queryParams.hub_name = params.hub_name;
    }

    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value != null)
    );

    const queryString = new URLSearchParams(cleanParams).toString();
    const url = `${GET_PINCODE_SERVICEABILITY}?${queryString}`;

    try {
      const response = await NormalAPI.Api(url).getCustomHeader(options);
      if (response?.status) {
        const responseData = response?.response?.data;
        return {
          data: responseData?.data || [],
          total: responseData?.totalCount || responseData?.pagination?.total || 0,
          page: responseData?.page || responseData?.pagination?.page || 1,
          limit: responseData?.limit || responseData?.pagination?.limit || 20,
        };
      }
      throw new Error(response?.message || "Failed to fetch pincode serviceability");
    } catch (error) {
      console.error("Error fetching pincode serviceability:", error);
      throw error;
    }
  },
  createPincode: async (payload) => {
    try {
      const response = await NormalAPI.Api(GET_PINCODE_SERVICEABILITY).postWithHeader(payload);
      if (response?.status) {
        return response.response?.data ?? response.data;
      }
      const errorData = response?.response?.data;
      throw new Error(
        errorData?.message || response?.message || "Failed to create pincode serviceability",
      );
    } catch (error) {
      console.error("Error creating pincode:", error);
      throw error;
    }
  },
  createPincodeMetadata: async (payload) => {
    try {
      const response = await NormalAPI.Api(CREATE_SINGLE_PINCODE_METADATA).postWithHeader(payload);
      if (response?.status) {
        return response.response?.data ?? response.data;
      }
      const errorData = response?.response?.data;
      throw new Error(
        errorData?.message || response?.message || "Failed to create pincode metadata",
      );
    } catch (error) {
      console.error("Error creating pincode metadata:", error);
      throw error;
    }
  },
  updatePincode: async (payload) => {
    try {
      // Assuming PUT method for update, or use PATCH if preferred
      const response = await NormalAPI.Api(GET_PINCODE_SERVICEABILITY).putWithHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to update pincode");
    } catch (error) {
      console.error("Error updating pincode:", error);
      throw error;
    }
  },
  exportPincodeServiceability: async (params) => {
    const queryParams = {
      business_line: params.business_line,
    };

    if (params.search) {
      queryParams.global_search = params.search;
    }
    if (params.is_active !== undefined && params.is_active !== null) {
      queryParams.is_active = params.is_active;
    }
    if (params.state) {
      queryParams.state = params.state;
    }
    if (params.city) {
      queryParams.city = params.city;
    }
    if (params.pincode) {
      queryParams.pincode = params.pincode;
    }
    if (params.zone) {
      queryParams.zone = params.zone;
    }
    if (params.hub_name) {
      queryParams.hub_name = params.hub_name;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${EXPORT_PINCODE_SERVICEABILITY}?${queryString}`;

    try {
      const response = await NormalAPI.Api(url).getCustomHeader({ responseType: "blob" });
      if (response?.status) {
        return response;
      }
      throw new Error(response?.message || "Failed to export pincode serviceability");
    } catch (error) {
      console.error("Error exporting pincode serviceability:", error);
      throw error;
    }
  },
  exportPincodeMetadata: async (params = {}) => {
    const queryParams = {};

    if (params.search) {
      queryParams.pincode = params.search;
    }
    if (params.pincode) {
      queryParams.pincode = params.pincode;
    }
    if (params.city) {
      queryParams.city = params.city;
    }
    if (params.state) {
      queryParams.state = params.state;
    }
    if (params.hub_name) {
      queryParams.hub_name = params.hub_name;
    }
    if (params.ecomm_zone) {
      queryParams.ecomm_zone = params.ecomm_zone;
    }
    if (params.courier_zone) {
      queryParams.courier_zone = params.courier_zone;
    }
    if (params.ecomm_billing_zone) {
      queryParams.ecomm_billing_zone = params.ecomm_billing_zone;
    }
    if (params.courier_billing_zone) {
      queryParams.courier_billing_zone = params.courier_billing_zone;
    }
    if (params.mcn) {
      queryParams.mcn = params.mcn;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `${EXPORT_PINCODE_METADATA}?${queryString}` : EXPORT_PINCODE_METADATA;

    try {
      const response = await NormalAPI.Api(url).getCustomHeader({ responseType: "blob" });
      if (response?.status) {
        return response;
      }
      throw new Error(response?.message || "Failed to export pincode metadata");
    } catch (error) {
      console.error("Error exporting pincode metadata:", error);
      throw error;
    }
  },
  getPincodeAreas: async (params, options = {}) => {
    const queryParams = {
      page: params.page || 1,
      limit: params.limit || 20,
    };
    if (params.search) {
      queryParams.pincode = params.search;
    }
    if (params.city) {
      queryParams.city = params.city;
    }
    if (params.state) {
      queryParams.state = params.state;
    }
    if (params.pincode) {
      queryParams.pincode = params.pincode;
    }
    if (params.hub_name) {
      queryParams.hub_name = params.hub_name;
    }
    if (params.ecomm_zone) {
      queryParams.ecomm_zone = params.ecomm_zone;
    }
    if (params.courier_zone) {
      queryParams.courier_zone = params.courier_zone;
    }
    if (params.ecomm_billing_zone) {
      queryParams.ecomm_billing_zone = params.ecomm_billing_zone;
    }
    if (params.courier_billing_zone) {
      queryParams.courier_billing_zone = params.courier_billing_zone;
    }
    if (params.mcn) {
      queryParams.mcn = params.mcn;
    }
    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value != null)
    );
    const queryString = new URLSearchParams(cleanParams).toString();
    const url = `${GET_PINCODE_METADATA}?${queryString}`;

    try {
      const response = await NormalAPI.Api(url).getCustomHeader(options);
      console.log("getPincodeAreas RAW RESPONSE:", response);
      if (response?.status) {
        const responseData = response?.response?.data?.data;
        return {
          data: Array.isArray(responseData?.items) ? responseData.items : [],
          total: responseData?.totalCount || 0,
          page: responseData?.page || 1,
          limit: responseData?.limit || 20,
        };
      }
      throw new Error(response?.message || "Failed to fetch pincode metadata");
    } catch (error) {
      console.error("Error fetching pincode metadata:", error);
      throw error;
    }
  },
  updatePincodeArea: async (payload) => {
    try {
      const response = await NormalAPI.Api(UPDATE_TRANSIT_DAYS).putWithHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to update transit days for delivery");
    } catch (error) {
      console.error("Error updating pincode area:", error);
      throw error;
    }
  },
  bulkUpdateZones: async (payload) => {
    try {
      const response = await NormalAPI.Api(BULK_UPDATE_ZONES).patchCustomHeader(payload);
      if (response?.status) {
        // Return the nested data structure
        return response?.response?.data || response.data;
      }
      throw new Error(response?.message || "Failed to update zones");
    } catch (error) {
      console.error("Error updating zones:", error);
      throw error;
    }
  },
  toggleService: async (payload) => {
    try {
      // payload is expected to be an array of objects e.g., [{"pincode":110001,"service_id":39}]
      const response = await NormalAPI.Api(TOGGLE_SERVICE_URL).patchCustomHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to toggle service");
    } catch (error) {
      console.error("Error toggling service:", error);
      throw error;
    }
  },
  togglePincodeActive: async (payload) => {
    try {
      // payload: {"pincodes":[110000],"isActive":true,"businessLine":"ecomm"}
      const response = await NormalAPI.Api(TOGGLE_ACTIVE_URL).patchCustomHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to toggle pincode active status");
    } catch (error) {
      console.error("Error toggling pincode active status:", error);
      throw error;
    }
  },
  getStates: async () => {
    try {
      const response = await NormalAPI.Api(GET_ALL_STATE).getCustomHeader();
      if (response?.status) {
        return response?.response?.data || [];
      }
      throw new Error(response?.message || "Failed to fetch states");
    } catch (error) {
      console.error("Error fetching states:", error);
      throw error;
    }
  },
  getHyperlocalStates: async () => {
    try {
      const response = await NormalAPI.Api(GET_STATES_HYPERLOCAL).getCustomHeader();
      if (response?.status) {
        const data = response?.response?.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.data)) return data.data;
        return [];
      }
      throw new Error(response?.message || "Failed to fetch hyperlocal states");
    } catch (error) {
      console.error("Error fetching hyperlocal states:", error);
      throw error;
    }
  },
  getCities: async (stateName) => {
    try {
      const response = await NormalAPI.Api(`${GET_CITIES_BY_STATE}?state=${stateName}`).getCustomHeader();
      console.log("getCities response:", response);
      if (response?.status) {
        const data = response?.response?.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.cities)) return data.cities;
        if (data && Array.isArray(data.city)) return data.city;
        if (data && Array.isArray(data.data)) return data.data;
        return [];
      }
      throw new Error(response?.message || "Failed to fetch cities");
    } catch (error) {
      console.error("Error fetching cities:", error);
      throw error;
    }
  },
  getHyperlocalZones: async (cityName) => {
    try {
      const response = await NormalAPI.Api(`${GET_HYPERLOCAL_ZONES}?city=${cityName}`).getCustomHeader();
      console.log("getHyperlocalZones RAW RESPONSE:", response);
      if (response?.status) {
        const data = response?.response?.data;
        // Handle { data: { items: [] } } pattern (Common in this app)
        if (data?.data && Array.isArray(data.data.items)) {
          return data.data.items;
        }
        // Handle { items: [] } pattern
        if (data && Array.isArray(data.items)) {
          return data.items;
        }
        // Handle direct array response
        if (Array.isArray(data)) {
          return data;
        }
        return [];
      }
      throw new Error(response?.message || "Failed to fetch hyperlocal zones");
    } catch (error) {
      console.error("Error fetching hyperlocal zones:", error);
      throw error;
    }
  },
  updateHyperlocalZone: async (payload) => {
    try {
      const response = await NormalAPI.Api(UPDATE_HYPERLOCAL_ZONE).putWithHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to update hyperlocal zone");
    } catch (error) {
      console.error("Error updating hyperlocal zone:", error);
      throw error;
    }
  },
  createHyperlocalZone: async (payload) => {
    try {
      const response = await NormalAPI.Api(CREATE_HYPERLOCAL_ZONE).postWithHeader(payload);
      if (response?.status) {
        return response.data;
      }
      throw new Error(response?.message || "Failed to create hyperlocal zone");
    } catch (error) {
      console.error("Error creating hyperlocal zone:", error);
      throw error;
    }
  },
  bulkUploadPincode: async (file, businessLine) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      let uploadUrl = BULK_UPLOAD_PINCODE;
      if (businessLine === "courier") {
        uploadUrl = BULK_UPLOAD_COURIER_PINCODE;
      } else if (businessLine === "ecomm") {
        uploadUrl = BULK_UPLOAD_ECOMM_PINCODE;
      } else if (businessLine === "metadata") {
        uploadUrl = BULK_UPLOAD_PINCODE_METADATA;
      } else if (businessLine === "mcn") {
        uploadUrl = BULK_UPLOAD_MCN_PINCODE;
      }

      const response = await NormalAPI.Api(uploadUrl).postWithHeader(formData);

      if (response?.status) {
        return response.response.data;
      }
      
      const errorData = response?.response?.data;
      if (errorData && (errorData.failed_rows || errorData.success === false || errorData.statusCode >= 400 || errorData.error)) {
        return errorData;
      }

      throw new Error(errorData?.message || response?.message || "Failed to upload file");
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  },
  getServiceabilityStates: async () => {
    try {
      const response = await NormalAPI.Api(GET_SERVICEABILITY_STATES).getCustomHeader();
      if (response?.status) {
        return response?.response?.data?.data || [];
      }
      throw new Error(response?.message || "Failed to fetch states");
    } catch (error) {
      console.error("Error fetching states:", error);
      throw error;
    }
  },
  getServiceabilityCities: async (stateId) => {
    try {
      const response = await NormalAPI.Api(`${GET_SERVICEABILITY_CITIES}${stateId}`).getCustomHeader();
      if (response?.status) {
        return response?.response?.data?.data || [];
      }
      throw new Error(response?.message || "Failed to fetch cities");
    } catch (error) {
      console.error("Error fetching cities:", error);
      throw error;
    }
  },
  createCity: async (payload) => {
    try {
      const response = await NormalAPI.Api(CREATE_SERVICEABILITY_CITY).postWithHeader(payload);
      if (response?.status) {
        return response.response.data;
      }
      throw new Error(response?.response?.data?.message || response?.message || "Failed to create city");
    } catch (error) {
      console.error("Error creating city:", error);
      throw error;
    }
  },
  updateCity: async (cityId, payload) => {
    try {
      const url = `${UPDATE_SERVICEABILITY_CITY}/${cityId}`;
      const response = await NormalAPI.Api(url).patchCustomHeader(payload);
      if (response?.status) {
        return response.response.data;
      }
      throw new Error(response?.response?.data?.message || response?.message || "Failed to update city");
    } catch (error) {
      console.error("Error updating city:", error);
      throw error;
    }
  },
  getZones: async (businessLine) => {
    try {
      const response = await NormalAPI.Api(`${GET_ZONES}?business_line=${businessLine}`).getCustomHeader();
      if (response?.status) {
        return response?.response?.data?.data || [];
      }
      throw new Error(response?.message || "Failed to fetch zones");
    } catch (error) {
      console.error("Error fetching zones:", error);
      throw error;
    }
  },
  getBillingZones: async (businessLine) => {
    try {
      const response = await NormalAPI.Api(`${GET_BILLING_ZONES}?business_line=${businessLine}`).getCustomHeader();
      if (response?.status) {
        return response?.response?.data?.data || [];
      }
      throw new Error(response?.message || "Failed to fetch billing zones");
    } catch (error) {
      console.error("Error fetching billing zones:", error);
      throw error;
    }
  },
  createZone: async (payload) => {
    try {
      const response = await NormalAPI.Api(CREATE_ZONE).postWithHeader(payload);
      if (response?.status) {
        return response?.data;
      }
      throw new Error(response?.message || "Failed to create zone");
    } catch (error) {
      console.error("Error creating zone:", error);
      throw error;
    }
  },
  createBillingZone: async (payload) => {
    try {
      const response = await NormalAPI.Api(CREATE_BILLING_ZONE).postWithHeader(payload);
      if (response?.status) {
        return response?.data;
      }
      throw new Error(response?.message || "Failed to create billing zone");
    } catch (error) {
      console.error("Error creating billing zone:", error);
      throw error;
    }
  }
};
